import { Stack } from "@mui/material";
import { To } from "react-router";

import { AreaCard } from "~/modules/plannerV2/components/AreaCard/AreaCard";
import { AreaCardVisitItem } from "~/modules/plannerV2/components/AreaCard/AreaCardVisitItem";
import { FieldworkerAssignments } from "~/modules/plannerV2/components/FieldworkerAssignments";

import { VisitTimelineItemFragment } from "./fragments.generated";

interface VisitTimelineItemProps {
    visit: VisitTimelineItemFragment;
    visitClickHref: (plannerAreaId: string, plannerVisitId: string) => To;
    areaNameHref: (plannerAreaId: string) => To;
    removable?: boolean;
    onRemoveClick?: (visitId: string) => void;
    loadingToRemoveVisitId: string | null;
}

export function VisitTimelineItem({
    visit,
    visitClickHref,
    areaNameHref,
    removable,
    onRemoveClick,
    loadingToRemoveVisitId,
}: VisitTimelineItemProps) {
    const isRemoving = loadingToRemoveVisitId === visit.visitId;

    return (
        <Stack flexGrow={1} sx={{ opacity: isRemoving ? 0.5 : 1 }}>
            <AreaCard
                area={visit.plannerArea}
                areaNameHref={areaNameHref}
                removable={removable}
                onRemoveClick={isRemoving ? undefined : () => onRemoveClick?.(visit.visitId)}
            >
                <AreaCardVisitItem href={visitClickHref(visit.plannerArea.id, visit.visitId)} visit={visit} />
                <FieldworkerAssignments
                    fieldworkers={visit.fieldworkersStaged}
                    fieldworkersRequired={visit.requiredFieldworkers}
                    variant="list"
                />
            </AreaCard>
        </Stack>
    );
}
